import { Paper } from '@mui/material';

export default function MessagePaper({ children, sent }) {
  return (
    <Paper sx={{
      maxWidth: '60%',
      backgroundColor: sent ? '#eee' : 'white',
      border: sent ? 'none' : '1px solid #ddd',
      boxShadow: 'none',
      borderRadius: '10px',
    }}
    >

      {children}
    </Paper>
  );
}
